import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import BackingOurStrength from './components/backingOurStrength';
import ClientsFirstSection from './components/clientsFirstSection';
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import FinancialPlanningSection1 from './components/financialPlanningSection1';
import FinancialPlanningSection2 from './components/financialPlanningSection2';
import FinancialPlanningSection3 from './components/financialPlanningSection3';
import FinancialStatementsSection from './components/financialStatementsSection';
import HeroSection from './components/heroSection';
import InvestmentHoldingsSection from './components/investmentHoldingsSection';
import RelatedLinksSection1 from './components/relatedLinksSection1';
import RelatedLinksSection2 from './components/relatedLinksSection2';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Who we are',
          linkUrl: '/who-we-are/',
          linkAriaLabel: 'Northwestern Mutual Who We Are',
        },
        {
          pageName: 'Financial Information',
          linkUrl: '/financial-information/',
          linkAriaLabel: 'Northwestern Mutual Financial Information',
        },
      ]}
      disableDisclaimerTopBorder
      disclaimerFootnotes={[
        <>
          <sup>1</sup>&nbsp;Ratings are for The Northwestern Mutual Life Insurance Company and Northwestern Long Term Care Insurance Company as of the most recent review and report by each rating agency. Ratings are as of 5&#47;25 (Moody&#39;s Ratings), 10&#47;24 (A.M. Best Company), 1&#47;25 (Fitch Ratings) and 4&#47;24 (S&#38;P Global Ratings). Ratings are subject to change.
        </>,
        <>
          <sup>2</sup>&nbsp;S&#38;P Global Ratings and Moody&#39;s Ratings caps Northwestern Mutual&#39;s rating at their AA&#43; (S&#38;P Global Ratings) and Aa1 (Moody&#39;s Ratings) ratings of the U.S. government.
        </>,
      ]}>

      <HeroSection />

      <FinancialPlanningSection1 />

      <FinancialPlanningSection2 />

      <FinancialPlanningSection3 />

      <CredentialCalloutGrouping />

      <FinancialStatementsSection />

      <BackingOurStrength />

      <RelatedLinksSection1 />

      <InvestmentHoldingsSection />

      <ClientsFirstSection />

      <RelatedLinksSection2 />

    </Page>
  );
};
